import { getMapStyleJS } from '@/utilities/mapStyleUtils'

/**
 * Middleware to automatically close the data table when the layer it's displaying is hidden
 */
const dataTableLayerVisibilityMiddleware = store => next => action => {
  // Get state before action is processed to check current visibility
  const stateBefore = store.getState()

  // Process the action first
  const result = next(action)

  // Check if this is a layer visibility action that could hide layers
  if (
    action.type === 'TOGGLE_MAP_LAYER' ||
    action.type === 'TOGGLE_MAP_LAYERS_OFF'
  ) {
    const stateAfter = store.getState()
    const { dataTable } = stateAfter

    // If data table is open and has a layerId
    if (dataTable && dataTable.layerId) {
      const hiddenLayerIds = action.payload || []

      // Check if the currently displayed layer in the data table is being affected
      if (hiddenLayerIds.includes(dataTable.layerId)) {
        let shouldCloseDataTable = false

        if (action.type === 'TOGGLE_MAP_LAYERS_OFF') {
          // TOGGLE_MAP_LAYERS_OFF always hides layers
          shouldCloseDataTable = true
        } else if (action.type === 'TOGGLE_MAP_LAYER') {
          // For TOGGLE_MAP_LAYER, we need to check if the layer is now hidden
          // by looking at the map style state after the action
          const { mapStyle } = stateAfter
          if (mapStyle) {
            const mapStyleJS = getMapStyleJS(mapStyle)
            if (!mapStyleJS) return result
            const targetLayer = mapStyleJS.layers.find(
              layer => layer.id === dataTable.layerId
            )

            // If the layer exists and its visibility is now 'none', close the data table
            if (
              targetLayer &&
              targetLayer.layout &&
              targetLayer.layout.visibility === 'none'
            ) {
              shouldCloseDataTable = true
            }
          }
        }

        if (shouldCloseDataTable) {
          // Close the data table by setting it to null
          store.dispatch({
            type: 'SET_DATA_TABLE',
            payload: null,
          })
        }
      }
    }
  }

  return result
}

export default dataTableLayerVisibilityMiddleware
